import React from 'react';

function Climbing() {
  const climbingAchievements = [
    {
      title: "The Big Cheese, Nowra, 8c+",
      description: "This route takes on the most incredible feature I've ever climbed on, 40 metres of 50 degree overhanging sandstone. It had been on my life list ever since I first visited Cheesedale. After a couple of seasons trying it out and getting completely shut down by the outrageous boulder crux in the middle of the route, I finally gave it the effort it deserved and got the second repeat of it in July 2024. 10/10!",
      imageUrl: "cutloose.jpg"
    },
    {
      title: "White Ladder Ext, Nowra, 8c/+",
      description: "Australia's first 8c+ is a punchy little number. Attack Mode is an 8b+ that finishes halfway up this already short route. It was my first port of call when I first arrived in Nowra in 2022 and was a struggle at the time; continuing felt inconceivable. Recent ascentionists suggested that different beta takes some of the sting out of it and that it might be a grade easier. Interested to test the theory out, I jumped back on it off the back of my send of The Big Cheese and was surprised to find myself clipping the anchors after two short sessions.",
      imageUrl: "serp.jpg"
    },
    {
      title: "Mousetrap, Nowra, 8b? FA",
      description: "Located between the best bits of Cheesedale, this line seemed improbable at first, climbing through multiple roofs and interesting faces and through the distinctive Mickey Mouse feature. With some funky sequences, it could be a few grades easier or harder than suggested. Unfortunately, with an often wet start and difficult rope management, it's quite a faffy climb and may wait some time for a repeat.",
      imageUrl: "cheesecakelow.jpg"
    },
    {
      title: "The Box/ Cheese Change, Nowra, 8c",
      description: "My main objective on my breakout Nowra season, this climb taught me a lot about the process of projecting. It's an excellent climb, with interesting climbing all the way up, culminating in a difficult boulder and a dyno to finish. It was my first 8c and in hindsight I'm proud of how I went about the projecting process.",
      imageUrl: "thebox.jpg"
    },
    {
      title: "Punks In the Gym, Arapiles, 8b+",
      description: "Australia's first 8b+, first ascended by the legendary Wolfgang Gullich. It was an ambitious first project when I first came to Australia, considering 8a was a stretch at the time. Unfortunately, it was just too good to stop trying and given the ease of living in the Pines and jumping on it, I slowly worked it down to my level. This was a watershed send for me and showed me that I could get on harder climbs and succeed.",
      imageUrl: "punks.jpg"
    },
    {
      title: "Statement of Youth, Lower Pen Trywn, 8a",
      description: "The UK's and my first 8a. Starting climbing 15 years ago, this seemed like the pinnacle of what was possible for me and was a really big pedestal in my head. This led to some unpleasant mental states in the projecting process as I put too much pressure on myself, but I learned from this and continue to reflect on it whenever I find myself getting moody when I'm supposed to be having fun.",
      imageUrl: "china.jpg"
    }
  ];

  return (
    <div className="climbing">
      <h1>Rock Climbing</h1>
      <p>I have been climbing for over 15 years, and have climbed routes up to 8c+ and boulders up to 8A+. I've developed routes and done a handful of first ascents over 8a. Here are some of my proudest climbing achievements:</p>
      <p>Check out my full logbook at 8a.nu/users/matt-warner/sportclimbing.</p>
      <div className="climbing-achievements">
        {climbingAchievements.map((achievement, index) => (
          <div key={index} className="climb-card">
            <h3>{achievement.title}</h3>
            <div className="image-placeholder" style={{backgroundImage: `url(${achievement.imageUrl})`}}></div>
            <p>{achievement.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Climbing;